import React, { useState, useEffect, useContext } from 'react';

import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

import Box from '@mui/material/Box';
import {
  Grid,
  Checkbox,
  FormControlLabel,
  LinearProgress,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { useTheme } from 'styled-components';
import * as Styled from './styled';
import Button from '../Button';
import Modal from '../Modal';
import NewDocumentType from '../DocumentType';
import documentTypeClient from '../../clients/documentTypeClient';
import DeleteModalConfirmation from './DeleteModalConfirmation';
import EditModalUser from './EditModalUser';
import { AppContext } from '../../contexts/sidebarContext';
import SearchInput from '../SearchInput';

const useStyles = makeStyles(() => ({
  TableHead: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#107FAA',
    '@media (max-width: 1366px)': {
      fontSize: '12px !important',
    },
  },

  TableBody: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#107FAA',
    '@media (max-width: 1366px)': {
      fontSize: '12px !important',
    },
  },

  HeadCellLeft: {
    display: 'flex',
    justifyContent: 'left',
    alignContent: 'center',
  },

  BodyCellLeft: {
    display: 'flex',
    justifyContent: 'left',
    alignContent: 'center',
  },

  HeadCellCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },

  BodyCellCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },

  Paper: {
    backgroundColor: '#f7f7f7 !important',
    borderRadius: '10px !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80px',
    margin: '8px 0',
    marginBottom: '15px',
    '@media (max-width: 1366px)': {
      height: '60px',
    },
  },
  LinearProgress: {
    width: '100%',
  },
}));

const transformValueLabel = [
  { value: 'DocumentosPessoais', label: 'Documentos Pessoais' },
  { value: 'HistoricoFuncional', label: 'Histórico Funcional' },
  { value: 'Exames', label: 'Exames' },
  { value: 'Certidões', label: 'Certidões' },
  { value: 'Declarações', label: 'Declarações' },
  { value: 'Atos', label: 'Atos' },
  { value: 'Requerimentos', label: 'Requerimentos' },
  { value: 'ConcursoPublico', label: 'Concurso Público' },
  {
    value: 'ProcessoSeletivoSimplificado',
    label: 'Processo Seletivo Simplificado',
  },
  { value: 'AtosAdministrativos', label: 'Atos Administrativos' },
  { value: 'Contratos', label: 'Contratos' },
  { value: 'Atestados', label: 'Atestados' },
  { value: 'EstagioProbatorio', label: 'Estágio Probatório' },
  { value: 'Processos', label: 'Processos' },
  { value: 'DocumentosGovernamentais', label: 'Documentos Governamentais' },
  { value: 'Legislacao', label: 'Legislação' },
  { value: 'AvaliacaoDeProdutividade', label: 'Avaliaçao De Produtividade' },
  { value: 'Capacitacoes', label: 'Capacitações' },
  { value: 'Diversos', label: 'Diversos' },
  { value: 'TceMs', label: 'TceMs' },
];

function ListDocumentsType() {
  const theme = useTheme();
  const classes = useStyles();
  const userDocument = documentTypeClient();

  const [getId, setGetId] = useState('');
  const [getDocument, setGetDocument] = useState({});
  const [documents, setDocuments] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(false);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [showInactiveItens, setShowInactiveItens] = useState(false);

  const context = useContext(AppContext);

  const { filteredList, filteringList, msgAlert } = context;

  const transformValueLabelFunction = (category) => {
    /* eslint-disable-next consistent-return */

    let categoryTransform;
    transformValueLabel.forEach((values) => {
      if (values.value === category) {
        categoryTransform = values.label;
      }
    });
    return categoryTransform;
  };

  useEffect(() => {
    setLoadingProgress(true);
    userDocument()
      .getDocumentType()
      .then((response) => {
        if (response) {
          setDocuments(response);
          filteringList(response);
          setLoadingProgress(false);
        } else {
          setDocuments([]);
          setLoadingProgress(false);
        }
      });
  }, []);

  const handleModalClick = () => {
    setModalStatus(!modalStatus);
  };

  const handleDelete = (userId, document) => {
    setGetDocument(document);
    setGetId(userId);
    setOpenModalConfirmation(true);
  };

  const enableOrDisableUser = (data) => {
    const updateUser = () => {
      const payload = [data].map((sectorData) => ({
        name: sectorData?.name,
        description: sectorData?.description,
        enabled: !sectorData?.enabled,
        tenantId: sectorData?.tenantId,
        categoryDocumentType: sectorData?.categoryDocumentType,
      }));

      return payload[0];
    };

    const msgResponse = () => {
      if (data?.enabled) {
        return 'Estrutura Desativada';
      }
      return 'Estrutura Ativada';
    };

    userDocument()
      .editByIdDocumentType(data?.id, updateUser())
      .then(
        (response) => {
          msgAlert({
            response,
            message: msgResponse(),
          });
        },
        (resp) => {
          msgAlert({
            response: resp,
          });
        }
      );
  };

  const handleEdit = (userId, document) => {
    setGetId(userId);
    setOpenModal(true);
    setGetDocument(document);
  };

  const handleText = (text) => {
    if (text?.length > 0) {
      if (text?.length > 25) {
        const docTypeEnd = text.slice(0, 25);
        return `${docTypeEnd} ...`;
      }
      return text;
    }
    return '-';
  };

  const handleTextDescription = (text) => {
    if (text?.length > 0) {
      if (text?.length > 30) {
        const docTypeEnd = text.slice(0, 30);
        return `${docTypeEnd} ...`;
      }
      return text;
    }
    return '-';
  };

  const alphabetOrder = (array, prop) =>
    array?.sort((a, b) => {
      if (a[prop]?.toLowerCase() < b[prop]?.toLowerCase()) {
        return -1;
      }
      if (a[prop]?.toLowerCase() > b[prop]?.toLowerCase()) {
        return 1;
      }
      return 0;
    });

  const showInactiveItensValueFunction = (enabled) => {
    if (showInactiveItens) {
      return true;
    }
    return enabled;
  };

  const colorPowerFunction = (enabled) => {
    if (enabled) {
      return '#18FF59';
    }
    return 'red';
  };

  return (
    <>
      <Styled.Container>
        <Grid spacing={4} container>
          <Grid
            display="flex"
            justifyContent="center"
            alignItems="center"
            item
            xs={8}
          >
            <SearchInput
              list={documents}
              searchFieldName={['name', 'description']}
            />
          </Grid>
          <Grid
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            item
            xs={4}
          >
            <Button
              onClick={handleModalClick}
              text="+ Adicionar"
              width="300px"
              height="45px"
            />
          </Grid>
        </Grid>
      </Styled.Container>

      <Box display="flex" justifyContent="start" ml={5}>
        <FormControlLabel
          sx={{
            '& .MuiTypography-root': {
              display: 'flex',
              fontSize: '15px !important',
              fontStyle: 'normal !important',
              alignItems: 'center !important',
              fontFamily: 'Montserrat !important',
              fontWeight: 600,
              color: '#107faa !important',
              '@media (max-width: 1366px)': {
                fontSize: '12px !important',
              },
            },
          }}
          label="Mostrar inativos"
          control={
            <Checkbox
              checked={showInactiveItens}
              onChange={() => {
                setShowInactiveItens(!showInactiveItens);
              }}
              sx={{
                '&.Mui-checked': {
                  color: theme.background.blue,
                },
              }}
            />
          }
        />
      </Box>

      <Box
        mt={2}
        sx={{ padding: '20px' }}
        display="flex"
        justifyContent="flex-start"
      >
        <Styled.Title>Listagem de Tipos de Documentos</Styled.Title>
      </Box>
      <Styled.Container>
        <Grid
          display="flex"
          justifyContent="center"
          container
          mb={3}
          columns={40}
          className={classes.TableHead}
        >
          <Grid className={classes.HeadCell} item xl={10} xs={10}>
            Nome do Documento
          </Grid>
          <Grid className={classes.HeadCell} item xl={10} xs={10}>
            Categoria
          </Grid>
          <Grid className={classes.HeadCell} item xl={12} xs={10}>
            Descrição do Documento
          </Grid>
          <Grid className={classes.HeadCellCenter} item xl={5} xs={5}>
            Opções
          </Grid>
        </Grid>

        <Box
          sx={{
            width: '100%',
          }}
        >
          {alphabetOrder(filteredList, 'name').map((document) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {showInactiveItensValueFunction(document.enabled) && (
                <Paper className={classes.Paper} key={document.id}>
                  <Grid
                    display="flex"
                    justifyContent="center"
                    container
                    columns={40}
                    className={classes.TableBody}
                  >
                    <Grid className={classes.BodyCellLeft} xl={10} xs={10}>
                      {handleText(document.name)}
                    </Grid>
                    <Grid className={classes.BodyCellLeft} xl={10} xs={10}>
                      {transformValueLabelFunction(
                        document.categoryDocumentType
                      )}
                    </Grid>
                    <Grid className={classes.BodyCellLeft} xl={12} xs={10}>
                      {handleTextDescription(document.description)}
                    </Grid>
                    <Grid className={classes.BodyCellCenter} xl={5} xs={5}>
                      <Grid
                        container
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        spacing={1}
                      >
                        <Grid
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          item
                        >
                          <EditIcon
                            onClick={() => {
                              handleEdit(document.id, document);
                            }}
                            sx={{ cursor: 'pointer', color: '#107FAA' }}
                          />
                        </Grid>
                        <Grid
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          item
                        >
                          <DeleteForeverIcon
                            onClick={() => {
                              handleDelete(document.id, document);
                            }}
                            sx={{ cursor: 'pointer', color: 'red' }}
                          />
                        </Grid>
                        <Grid
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          title="Ativar/desativar documento"
                          item
                        >
                          <PowerSettingsNewIcon
                            onClick={() => {
                              enableOrDisableUser(document);
                            }}
                            sx={{
                              cursor: 'pointer',
                              color: colorPowerFunction(document.enabled),
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              )}
            </>
          ))}

          {loadingProgress && (
            <Box sx={{ width: '100%' }}>
              <LinearProgress variant="indeterminate" />
            </Box>
          )}
        </Box>
      </Styled.Container>

      <Modal status={modalStatus} setStatus={setModalStatus}>
        <NewDocumentType />
      </Modal>

      {openModal && (
        <EditModalUser
          getId={getId}
          getDocument={getDocument}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      )}

      {openModalConfirmation && (
        <DeleteModalConfirmation
          getId={getId}
          getDocument={getDocument}
          open={openModalConfirmation}
          setOpen={setOpenModalConfirmation}
        />
      )}
    </>
  );
}

export default ListDocumentsType;
